<template>
    <a-layout class="layout">
        <a-layout-header class="thyroid-light">
            <div class="header-width">
                <a-space>
                    <a href="/">
                        <img :src="require('@/assets/bioinfogpt.logo.png')" alt="" height="70px"/>
                    </a>
                    <a-menu
                            :selected-keys="openKeys"
                            style="line-height: 64px;width:800px"
                            mode="horizontal"
                            :items="items"
                            @click="handleClick"
                    ></a-menu>
                </a-space>
            </div>

        </a-layout-header>
        <!-- App.vue 或其他布局组件 -->
        <router-view v-slot="{ Component }">
            <keep-alive>
                <component :is="Component" />
            </keep-alive>
        </router-view>
        <a-layout-footer style="text-align: center;padding-top: 10px">
            BioMedAgent©2024-2025
        </a-layout-footer>
    </a-layout>
</template>
<script>
    import {h} from 'vue';
    import {
        HomeOutlined, BarChartOutlined,
        ToolOutlined
    } from '@ant-design/icons-vue';

    export default {
        name: 'App',
        components: {
            // selectedKeys: '1'
        },
        data() {
            let {pathname} = window.location;
            let [,key] = pathname.split('/');
            console.log(pathname, key);
            return {
                openKeys: [key || 'Home'],
                items: [
                    {
                        key: 'Home', label: 'Home',
                        icon: ()=> h(HomeOutlined)
                    },
                    {
                        key: 'Benchmark', label: 'Benchmark',
                        icon: ()=> h(BarChartOutlined)
                    },
                    {
                        key: 'Testing', label: 'Testing',
                        icon: ()=> h(BarChartOutlined)
                    },
                    {
                        key: 'Tools', label: 'Tools',
                        icon: ()=> h(ToolOutlined),
                    },
                ]
            };
        },
        methods: {
            handleClick(e){
                console.log('click', e);
                let {key} = e;
                window.location.href = '/' + (key === 'Home'? '': key);
            }
        }
    }
</script>

<style scoped>
    @import url('./main.css');


    .thyroid-light {
        background: #fff;
        border-bottom: 1px solid rgba(5, 5, 5, 0.06);
    }
</style>
